import type { JobPostingSkillFragment } from '@xing-com/crate-jobs-graphql';
import type { JobDetails, Preference } from '@xing-com/crate-jobs-helpers';

import {
  JobsXingletWrapper,
  type XingletInterface,
} from '../../../jobs-xinglet';

import { MatchingSkillsSkeleton } from './matching-skills-skeleton';

export type MatchingSkillsProps = {
  job: JobDetails;
  matchedPreferences?: Preference[];
  matchedSkills?: JobPostingSkillFragment[];
  notMatchedSkills?: JobPostingSkillFragment[];
};

export type MatchingSkillsXinglet = XingletInterface<MatchingSkillsProps>;

export const MatchingSkills = JobsXingletWrapper<MatchingSkillsProps>(
  '@xing-com/crate-jobs-domain-job-details-matching-skills',
  <MatchingSkillsSkeleton />
);
